var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#75994e}.st1{fill:#6a8e49}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.8 19.5s1.7 2.3 2.1 3.3c.4.9 4.5 11.6 4.5 11.6l5.6 4 15.5 39.4 9.8 21.2s-.1 7.8-.8 11.8-12.5 17.1-12.5 17.1-13.6 28.7-17.2 32.1-8.6 2.2-8.6 2.2l-1.6-6.1-20.4-21.5L64 107.4s-1.4-22.5 2.3-32.1c3.7-9.7 2.8-9.6 2.8-9.6l3.6-9.4 4.8-4.1 10-16.2 5.8-.3 1.2-4.8 4.5-7.8z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PZCpuc.tif"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9 91.6c.6-2.6.6-4.9.9-7.3 1.1-7.3 2.6-14.3 5.1-20.5.6.9.9 1.9 1.3 3 9 26.7 17.7 53.5 27.1 80.4.2.6.2 1.5 1.3 1.9-.6 3.2-.9 6.4-1.5 9.6 0 .9 0 1.9-1.3 2.3-7-5.8-13.4-11.9-18.8-19.4-7.7-10.9-12.6-22.4-14.1-35.6 0-.2 0-.9-.2-.9.2-4.8.2-9 .2-13.5",
    className: "st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 148.9c-.9 0-.9-1.3-1.3-1.9-9-26.4-18.1-53.5-27.1-80.4-.2-.9-.6-1.7-1.3-2.8 1.9-6.4 4.9-11.9 8.5-17.7 4.5-7 10.2-13.4 16.6-18.8 2.3-1.9 3.8-4.5 3.8-7.9.6.6.9 1.3.9 1.9-.6.2-.2.9-.2 1.5 1.3 6.2 1.3 11.7 1.3 17.5.2 12.8.2 24.9.2 37.7v7.3c0 7 0 14.1.2 20.9 0 3.8 0 7.7-.2 11.1-.2 4.9 0 10.2-.2 15.1-.2 3.4-.2 7-.2 10.4-.8 2.3-.6 4.2-1 6.1",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.6 106.5c-.2-7-.2-14.1-.2-20.9v-7.3c0-12.8 0-24.9-.2-37.7-.2-5.8-.2-11.3-.9-17.3 0-.6-.2-1.3.2-1.5 2.6 6.6 7.9 11.3 12.6 16.8 11.7 13.4 18.8 28.8 22.2 46.1.9 5.5 1.3 11.1.9 16.6-1.5.2-3.2.2-4.7.6-5.5.9-10.9 1.9-16.6 2.6-4.1.5-8.8 1.6-13.3 2",
    className: "st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.6 106.5c4.5 0 9-1.3 13.4-1.9 5.5-.6 10.9-1.5 16.6-2.6 1.5-.2 3.2-.2 4.7-.6-.2 7.7-1.5 15.1-4.1 23-4.9 14.5-13.6 26.4-25.6 35.6-2.3-.6-3.2-2.6-3.8-4.5-1.3-3.8-1.9-7.9-1.9-11.7.2-3.4 0-7 .2-10.4.6-4.9 0-10.2.2-15.1.3-4.5.1-8.2.3-11.8",
    style: {
      fill: "#668746"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5 143.2c0 4.1.6 7.9 1.9 11.7.6 1.9 1.5 3.8 3.8 4.5-1.9 2.3-2.6 4.9-2.6 7.9-.2 4.1-.6 8.1 0 12.6 0 .2 0 .6-.6.6-2.6 0-3.8-1.3-3.8-3.8 0-5.5-.6-10.9-2.6-16 1.3-.2 1.3-1.5 1.3-2.3.6-3.2.9-6.4 1.5-9.6.5-1.8.3-3.7 1.1-5.6",
    style: {
      fill: "#c0bebd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.42f6d4b28f05f11dc86f569f93e8fdc3.svg";
export { ForwardRef as ReactComponent };